import React from "react";
import { Helmet } from "react-helmet";
import Button from "../components/button";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import supplierImg from "../images/suppliers.jpg";

const Suppliers = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Suppliers</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={supplierImg}>
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            Suppliers
          </h1>
        </div>
      </Header>
      <div className="py-5 bg-ghost-white">
        <div className="ms-47 me-47 py-4 fs-16">
          <p>
            Welcome to Afro Group Suppliers Portal, please complete the details
            required and we will contact you with any future requirements that
            fit your profile. Please note fields marked (*) are mandatory.
          </p>
          <p>Afro Group Supply Chain Management.</p>
        </div>
      </div>
      <section className="container-fluid">
        <section className="ms-47 me-47 pt-7 pb-7 fs-16">
          <section className="mx-0 mx-md-4 shadow p-5 rounded">
            <div>
              <h2 className="fs-32">General Information</h2>
              <p>The survey will take approximately 10 minutes to complete.</p>
              <p className="text-align-justify">
                By voluntarily submitting this information to Afro Group, we
                confirm this is publicly available information fit for purpose
                and correct at the time of submission. We are authorised to
                provide such information and consent to Afro Group using,
                processing, sharing and/or destroying this information in any
                way. Afro Group may retain this information but is under no
                obligation in respect of it. We consent to Afro Group or anyone
                with whom the information is shared contacting us.
              </p>
            </div>
            <div>
              <h3 className="fs-22 text-orange-ryb gilroy-bold">
                General Corporate Information
              </h3>
              <div className="my-4">
                <label htmlFor="name" className="fs-16 mb-4">
                  1. Name of Company (as it appears on Commercial registration)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="name"
                />
              </div>
              <div className="my-4">
                <label htmlFor="address" className="fs-16 mb-4">
                  2. Address (as it appears on Commercial Registration)
                </label>
                <textarea
                  rows="8"
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14"
                  id="address"
                />
              </div>
              <div className="my-4">
                <label htmlFor="mail" className="fs-16 mb-4">
                  3. Mailing Address
                </label>
                <input
                  type="email"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="mail"
                />
              </div>
              <div className="my-4">
                <label htmlFor="tel" className="fs-16 mb-4">
                  4. Telephone No.
                </label>
                <input
                  type="tel"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="tel"
                />
              </div>
              <div className="my-4">
                <label htmlFor="fax" className="fs-16 mb-4">
                  5. Fax No.
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="fax"
                />
              </div>
              <div className="my-4">
                <label htmlFor="email" className="fs-16 mb-4">
                  6. Email Address
                </label>
                <input
                  type="email"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="email"
                />
              </div>
              <div className="my-4">
                <label htmlFor="websiteLink" className="fs-16 mb-4">
                  7. Website Address
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="websiteLink"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactNumber1" className="fs-16 mb-4">
                  8. Contact Name(1)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactNumber1"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactTitle1" className="fs-16 mb-4">
                  9. Contact Title(1)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactTitle1"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactEmailAddress1" className="fs-16 mb-4">
                  10. Contact Email Address(1)
                </label>
                <input
                  type="email"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactEmailAddress1"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactNumber2" className="fs-16 mb-4">
                  11. Contact Name(2)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactNumber2"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactTitle2" className="fs-16 mb-4">
                  12. Contact Title(2)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactTitle2"
                />
              </div>
              <div className="my-4">
                <label htmlFor="contactEmailAddress2" className="fs-16 mb-4">
                  13. Contact Email Address(2)
                </label>
                <input
                  type="email"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="contactEmailAddress2"
                />
              </div>
              <div className="my-4">
                <label htmlFor="registrationNumber" className="fs-16 mb-4">
                  14. Company Incorporation/Registration Number
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="registrationNumber"
                />
              </div>
              <div className="my-4">
                <label htmlFor="registration" className="fs-16 mb-4">
                  15. Country of Incorporation/Registration
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="registration"
                />
              </div>
              <div className="my-4">
                <label htmlFor="taxRegistrationNumber" className="fs-16 mb-4">
                  16. VAT/Tax Registration Number
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="taxRegistrationNumber"
                />
              </div>
              <div className="my-4">
                <label htmlFor="establishesYear" className="fs-16 mb-4">
                  17. Year Established
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="establishesYear"
                />
              </div>
              <div className="my-4">
                <label htmlFor="establishesYear" className="fs-16 mb-4 d-block">
                  18. Working Languages
                </label>
                <div className="d-flex align-items-center">
                  <input type="radio" name="languages" value="English" />{" "}
                  <span className="mx-2 fs-14">English</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="languages" value="French" />{" "}
                  <span className="mx-2 fs-14">French</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="languages" value="Other" />{" "}
                  <span className="mx-2 fs-14">Other</span>
                </div>
              </div>
              <div className="my-4">
                <label htmlFor="countryOfOperation" className="fs-16 mb-4">
                  19. Country of operation (If multiple please list)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="countryOfOperation"
                />
              </div>
              <div className="my-4">
                <label htmlFor="fullLegalName" className="fs-16 mb-4">
                  20. Full legal name of Parent Company (If applicable)
                </label>
                <input
                  type="text"
                  placeholder="Enter your answer"
                  className="form-control py-3 fs-14 "
                  id="fullLegalName"
                />
              </div>
              {/* services */}
              <div>
                <h2 className="fs-28 text-orange-ryb gilroy-bold">
                  Services - Products Supplies
                </h2>
                <div className="my-4">
                  <p className="fs-16 mb-4 d-block">
                    21. Please identify list of products & services provided
                  </p>
                  <div>
                    <input
                      type="checkbox"
                      name="site-acquisition-and-civil-work"
                      id="site-acquisition-and-civil-work"
                    />{" "}
                    <label htmlFor="site-acquisition-and-civil-work">
                      Site Acquisition and Civil work
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="telecom-site-installation-and-commissioning"
                      id="telecom-site-installation-and-commissioning"
                    />{" "}
                    <label htmlFor="telecom-site-installation-and-commissioning">
                      Telecom Site Installation and Commissioning
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="tower-supply-and-construction-services"
                      id="tower-supply-and-construction-services"
                    />
                    <label htmlFor="tower-supply-and-construction-services">
                      Tower Supply and construction services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="electrical-works-and-power-systems"
                      id="electrical-works-and-power-systems"
                    />{" "}
                    <label htmlFor="electrical-works-and-power-systems">
                      Electrical works and power systems (Batteries, rectifiers,
                      cables etc)
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="generator-supply-and-services"
                      id="generator-supply-and-services"
                    />{" "}
                    <label htmlFor="generator-supply-and-services">
                      {" "}
                      Generator Supply and services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="maintenance-and-operations-services"
                      id="maintenance-and-operations-services"
                    />{" "}
                    <label htmlFor="maintenance-and-operations-services">
                      Maintenance and operations Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="optical-fiber-networks-and-services"
                      id="optical-fiber-networks-and-services"
                    />{" "}
                    <label htmlFor="optical-fiber-networks-and-services">
                      Optical Fiber networks and services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="technical-audit-services"
                      id="technical-audit-services"
                    />
                    <label htmlFor="technical-audit-services">
                      Technical Audit Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="warehousing-and-logistics"
                      id="warehousing-and-logistics"
                    />
                    <label htmlFor="warehousing-and-logistics">
                      Warehousing and logistics
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="other-site-services"
                      id="other-site-services"
                    />{" "}
                    <label htmlFor="other-site-services">
                      Other Site Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="security-services"
                      id="security-services"
                    />{" "}
                    <label htmlFor="security-services">Security Services</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="fuel-supply-and-transportation"
                      id="fuel-supply-and-transportation"
                    />
                    <label htmlFor="fuel-supply-and-transportation">
                      Fuel Supply and Transportation
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="other-site-equipment"
                      id="other-site-equipment"
                    />{" "}
                    <label htmlFor="other-site-equipment">
                      Other Site Equipment
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="computer-and-information-technology-equipment-and-services"
                      id="computer-and-information-technology-equipment-and-services"
                    />
                    <label htmlFor="computer-and-information-technology-equipment-and-services">
                      Computer and information Technology Equipment and Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="air-conditioning-services"
                      id="air-conditioning-services"
                    />
                    <label htmlFor="air-conditioning-services">
                      Air conditioning Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="environmental-equipment-and-services"
                      id="environmental-equipment-and-services"
                    />{" "}
                    <label htmlFor="environmental-equipment-and-services">
                      Environmental equipment and services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="property-management-services"
                      id="property-management-services"
                    />{" "}
                    <label htmlFor="property-management-services">
                      Property Management Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="travel-services"
                      id="travel-services"
                    />{" "}
                    <label htmlFor="travel-services">Travel Services</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="legal-services"
                      id="legal-services"
                    />{" "}
                    <label htmlFor="legal-services">Legal Services</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="PR-and-marketing-services"
                      id="PR-and-marketing-services"
                    />{" "}
                    <label htmlFor="PR-and-marketing-services">
                      PR and Marketing Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="financial-services"
                      id="financial-services"
                    />{" "}
                    <label htmlFor="financial-services">
                      Financial Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="HR-and-Payroll-services"
                      id="HR-and-Payroll-services"
                    />{" "}
                    <label htmlFor="HR-and-Payroll-services">
                      HR and Payroll Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="business-consulting-services"
                      id="business-consulting-services"
                    />{" "}
                    <label htmlFor="business-consulting-services">
                      Business Consulting Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="vehicle-hire-and purchases"
                      id="vehicle-hire-and purchases"
                    />{" "}
                    <label htmlFor="vehicle-hire-and purchases">
                      Vehicle Hire and Purchases/Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="office-support-services"
                      id="office-support-services"
                    />{" "}
                    <label htmlFor="office-support-services">
                      Office Support Services
                    </label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      name="office-equipment-and-supplies"
                      id="office-equipment-and-supplies"
                    />
                    <label htmlFor="office-equipment-and-supplies">
                      Office equipment and Supplies
                    </label>
                  </div>
                </div>
              </div>

              <div className="pt-5">
                <Button
                  text="submit"
                  cssName="border-0 bg-american-yellow fs-18 border-1 text-uppercase py-2 px-5 text-white gilroy-bold"
                />
              </div>
            </div>
          </section>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default Suppliers;
